import { useDispatch } from 'react-redux';
import React, { Fragment, useState } from 'react';
import _ from 'lodash';
import { oEmbedActions, proactiveActions } from '_actions';
import { isTimeToday } from '_helpers';
import { channelTypes } from '_constants';
import { isMetaSourcesForOEmbed } from '../Vote/Sections/BodySection/Conversation/OEmbed/EmbedUtils';
import { formatDateCreated } from './ProactiveMetricsDetailUtil';
import styles from './Utilities/styles.module.css';
import MessageListEmptyState from './Utilities/MessageListEmptyState';
import useLocationQueryParams from "../../hooks/useLocationQueryParams";

export const RetainMessageList = ({
                                      source,
                                      organizationId,
                                      msgList,
                                      setMessageLink,
                                      setMessageSource,
                                      loading,
                                      channel,
                                      setRetainaiSkipped
                                  }) => {
    const dispatch = useDispatch();
    const [selectedIndex, setSelectedIndex] = useState(null);
    const { params } = useLocationQueryParams();

    const onMessageSelect = (msg, index) => {
        const msgSourceName = _.toString(channel).toLowerCase();
        setMessageLink(msg.link);
        setMessageSource(msgSourceName);
        setSelectedIndex(index);
        setRetainaiSkipped(msg.retainaiSkipped)
        dispatch(proactiveActions.getProactiveMsgConversation(msg.id, organizationId, source));

        if (source === "MOBIUS"){
            const orderParams = {
                organizationId,
                customerEmail: msg.authorName,
                campaignId: params.campaignIds
            }
            dispatch(proactiveActions.getProactiveConversionOrders(msg.id, orderParams));
        }

        if (isMetaSourcesForOEmbed(msgSourceName, msg.displayInApp)) {
            dispatch(oEmbedActions.getMetaEmbed(msg.id));
        }
    };

    const isShopify = _.toString(channel).toUpperCase() === channelTypes.shopify;

    if (loading) {
        return (
            <div className={styles.bgWhite}>
                <MessageListEmptyState />
            </div>
        );
    }

    if (!Array.isArray(msgList) || msgList.length === 0) {
        return (
            <div className={styles.msgListEmpty}>
                <span>No messages found.</span>
            </div>
        );
    }

    return msgList.filter(Boolean).map((msg, i) => (
        <Fragment key={`${msg.id}-${i}`}>
            <div
                role="button"
                id={`${msg.id}-${i}`}
                className={selectedIndex === i ? styles.bgGray : styles.bgWhite}
                onClick={() => onMessageSelect(msg, i)}
            >
                <div className="message-list-container">
                    <div className="tms-truncate-2-lines message-list-text retain-list-text">
                        {isShopify ? msg.authorName : msg.text}
                    </div>
                    <div>
                        <div className="message-list-date retain-list-date">
                            {isTimeToday(msg.firstOutgoingMessageDate)
                                ? formatDateCreated(msg.firstOutgoingMessageDate, 'HH:mm a')
                                : formatDateCreated(msg.firstOutgoingMessageDate, 'DD-MMM-YYYY')}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    ));
};
